export const ROUTES = {
  AUTH: {
    LOGIN: 'auth/login',
    LOGOUT: 'logout',
    RESET_PASSWORD: 'password-reset',
    RESET_PASSWORD_CONFIRM: 'password-reset/confirm',
    GUEST_UPGRADE: 'guest-upgrade',
    GUEST_UPGRADE_RESEND_LINK: 'guest-upgrade/resend-link',
    SET_NEW_PASSWORD: 'password-reset/set-new',
    SET_NEW_PASSWORD_EXPIRED: 'password-reset/expired-reset',
  },
}
